import type React from 'react';
import SideDrawerFilter from 'src/HomePage/DrawerAndPushedContents/LeftSideDrawerContent/SideDrawerFilter/SideDrawerFilter';

const LeftSideDrawerContent: React.FC = () => {
  return <SideDrawerFilter />;
};

export default LeftSideDrawerContent;
